const spinnerUtils = {
  /**
   * @param  {HTMLElement} container to container in which the spinner shall be displayed
   * @return {String} token
   */
  create: (container = document.body) => {
    const overlay = document.createElement('div');
    const spinnerNode = document.createElement('div');
    const token = `spinner-${String(Math.floor(Math.random() * (9999)) + 1)}`;
    const target = container;

    // overlay
    overlay.id = token;
    overlay.classList.add('spinner--overlay');

    // wrapper
    spinnerNode.classList.add('spinner');
    spinnerNode.dataset.spinner = '';

    // add elements to spinner
    for (let i = 1; i <= 8; i += 1) {
      const element = document.createElement('div');

      // set id and classes
      element.id = `frotateG_0${i}`;
      element.classList.add('spinner--element');

      // add element to spinner
      spinnerNode.appendChild(element);
    }

    // assamble
    overlay.appendChild(spinnerNode);
    target.appendChild(overlay);

    return token;
  },

  /**
   * @param  {String} token token to identify the spinner
   * @return {void}
   */
  destroy: (token) => {
    const spinner = document.getElementById(token);

    // remove spinner
    if (spinner !== null) spinner.parentNode.removeChild(spinner);
  },
};

export default spinnerUtils;



// WEBPACK FOOTER //
// ./assets/js/components/spinner.js